




































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import CtaButton from '@/modules/shared/components/shared/kit/CtaButton.vue'
import SocialIcon from '@/modules/shared/components/shared/icon/SocialIcon.vue'
import BaseDrawer from '@/modules/common/layout/components/shared/base/BaseDrawer.vue'
import { PanelContentCampaignRoute } from '@/modules/content-campaign/routes/panel-content-campaign.route'

@Component({
  components: { BaseDrawer, SocialIcon, CtaButton }
})
export default class PanelDrawer extends Vue {
  constructor(
    private readonly routes: PanelContentCampaignRoute
  ) {
    super()
  }

  $refs: {
    baseDrawer: BaseDrawer
  }

  toggleDrawer() {
    this.$refs.baseDrawer.toggleDrawer()
  }

  closeDrawer() {
    if (this.$q.screen.lt.md) {
      this.$refs.baseDrawer.showDrawer = false
    }
  }
}
